export default {"src":"/_next/static/media/logistics.2c21c511.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};